/**
 * Created by wuhuping on 2017/6/5.
 */
import store from '../store'
import channel from './channel'
import Vue from 'vue'
export default {
  saveDeviceInfo(deviceInfo) {
    window.localStorage.setItem('deviceInfo', deviceInfo);
    // 外链默认解析地址里面的chanNo,app时解析原生回传的chanNo
    if (deviceInfo) {
      deviceInfo = JSON.parse(deviceInfo);
      if (deviceInfo.chanNo) {
        channel.updateChanNo(deviceInfo.chanNo);
      }
    }
  },
  fetchDeviceInfo() {
    return window.localStorage.getItem('deviceInfo');
  },
  getDeviceType() {
    let browser = {
      versions() {
        let u = navigator.userAgent;
        let app = navigator.appVersion;
        return {
          trident: u.indexOf('Trident') > -1, // IE内核
          presto: u.indexOf('Presto') > -1, // opera内核
          webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
          gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1, // 火狐内核
          mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
          ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
          android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, // android终端或者uc浏览器
          iPhone: u.indexOf('iPhone') > -1, // 是否为iPhone或者QQHD浏览器
          iPad: u.indexOf('iPad') > -1, // 是否iPad
          webApp: u.indexOf('Safari') === -1, // 是否web应该程序，没有头部与底部
          weixin: u.indexOf('MicroMessenger') > -1, // 是否微信 （2015-01-22新增）
          qq: u.match(/\sQQ/i) === 'qq' // 是否QQ
        };
      },
      language: (navigator.browserLanguage || navigator.language).toLowerCase()
    };

    return browser.versions();
  },
  isAndroidDevice() {
    // return !!this.getDeviceType().android;
    let deviceInfoOsType = '';
    if (this.fetchDeviceInfo()) {
      deviceInfoOsType = JSON.parse(this.fetchDeviceInfo()).ostype;
    }
    return !!(this.getDeviceType().android || deviceInfoOsType === '01');
  },
  isiOSDevice() {
    let versions = this.getDeviceType();
    return !!(versions.ios || versions.iPhone || versions.iPad);
  },
  isWeixin() {
    return !!this.getDeviceType().weixin;
  }
}



// WEBPACK FOOTER //
// ./src/tools/deviceInfo.js